/** Team Performance — `salescrmapi/src/modules/teamPerformance`. */
import apiClient from './axiosClient.js';
import { downloadPdf } from './letterhead.api.js';

const clean = (p) => Object.fromEntries(Object.entries(p).filter(([, v]) => v !== '' && v != null));

export async function getTeamPerformance(params) {
  return (await apiClient.get('/team-performance', { params: clean(params) })).data;
}
export async function getRepPerformance(id, params) {
  return (await apiClient.get(`/team-performance/reps/${id}`, { params: clean(params) })).data;
}
export async function setMonthlyTarget(payload) {
  return (await apiClient.put('/team-performance/targets', payload)).data;
}
/** CSV or PDF — fetched with the auth header, then saved by the browser. */
export function exportTeamPerformance(params, format) {
  const qs = new URLSearchParams({ ...clean(params), format }).toString();
  return downloadPdf(`/team-performance/export?${qs}`, `team-performance.${format}`);
}
